import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { GuidedTour, GuidedTourComponent, GuidedTourService, Orientation } from 'ngx-guided-tour';
import { AppComponent } from 'src/app/app.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'sd-screen-guide',
  templateUrl: './screen-guide.component.html',
  styleUrls: ['./screen-guide.component.scss'],
  // providers: [AppComponent]
})
export class ScreenGuideComponent implements OnInit {

  constructor(
    private appcomponent: AppComponent,
    public dialogRef: MatDialogRef<ScreenGuideComponent>
  ) {

  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close()
  }

  startTour() {
    this.onClose()
    this.appcomponent.screenGuide();
  }

  

}
